import React, { useEffect, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { t } from "react-multi-lang";
import { verification } from "../../Redux/usersReduce";
import MyCarousel from "../../components/Caroussel/MyCarousel";
import jwt_decode from "jwt-decode";
import { useDispatch } from "react-redux";
function MenuCmd({client,obj}) {
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);
  const deviceType = "desktop";
  const dispatch = useDispatch();
  var navigate = useHistory();

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
  }, []);



  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-menucmd">
          <MyCarousel deviceType={deviceType} type={2} client={client} />
          <div className="clearfix"></div>
          <br clear="all"></br>
          <Row className="justify-content-center">
            <Col md="8">

              <Card>
                <Card.Header>
                  <Card.Title as="h4">{t("new_order")}</Card.Title>
                  <br></br>
                </Card.Header>
                <Card.Body>
                  <div className="width50">
                    <Button
                      className="btn-cmd blue"
                      type="button"
                      onClick={() =>
                        navigate.push(client+"/AddCommandeListProduit")
                      }
                    >                      
                      <img src={require("../../assets/img/list.png")} title={t("order_list")}></img>
                      <br></br>{t("order_list")}
                    </Button>
                    <Button
                      className="btn-cmd"
                      type="button"
                      onClick={() =>
                        navigate.push(client+"/addCommande")
                      }
                    >
                      <img src={require("../../assets/img/pdf.png")} title={t("order_list_pdf")}></img>
                      <br></br>{t("order_list_pdf")}
                    </Button>
                  </div>

                  <div className="width50">
                    <Button
                      className="btn-cmd green"
                      type="button"
                      onClick={() =>
                        navigate.push(client+"/addCommandeExcel")
                      }
                    >
                       <img src={require("../../assets/img/xls.png")} title={t("order_list_excel")}></img>
                       <br></br>{t("order_list_excel")}
                    </Button>
                    <Button
                      className="btn-cmd gray"
                      type="button"
                      onClick={() =>
                        navigate.push(client+"/AddCommandeParProduit")
                      }
                    >
                       <img src={require("../../assets/img/nouvelle.png")} title={t("order_initier")}></img>
                        <br></br>{t("order_initier")}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div >
      </Container >

    </>
  );
}

export default MenuCmd;
